/* ============================================================================
   Product gallery — mirrors the Lovable ProductGallery + MagnifiedImage.
   - Thumbnail strip switches the main image
   - Magnifier lens on desktop hover (transform-origin follows cursor, scale 2.2)
   - Prev / next arrows, image counter
   - Mobile: tap opens fullscreen lightbox
   - Variant (colour) change filters images by alt-text group and resets to first
   ========================================================================== */
(function () {
  function initGallery(root) {
    if (!root || root.dataset.galleryInit === '1') return;
    root.dataset.galleryInit = '1';

    var stage = root.querySelector('[data-gallery-stage]');
    var magnify = root.querySelector('[data-magnify]');
    var mainImg = root.querySelector('[data-magnify-img]');
    var thumbsWrap = root.querySelector('[data-gallery-thumbs]');
    var counter = root.querySelector('[data-gallery-counter]');
    var counterCur = root.querySelector('[data-counter-current]');
    var counterTot = root.querySelector('[data-counter-total]');
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    var lightbox = root.querySelector('[data-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
    var lightboxClose = lightbox ? lightbox.querySelectorAll('[data-lightbox-close]') : [];

    // All slides carry data-group (colour handle) + data-full (hi-res url)
    var allSlides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var active = 0;
    var visible = allSlides.slice();

    var isTouch = window.matchMedia('(hover: none)').matches;

    function currentGroup() {
      return root.getAttribute('data-active-group') || '';
    }

    function computeVisible() {
      var group = currentGroup();
      var matched = allSlides.filter(function (s) {
        return (s.getAttribute('data-group') || '') === group;
      });
      // Fallback: if no image is tagged for this colour, show everything
      visible = matched.length ? matched : allSlides.slice();
    }

    function render() {
      if (!visible.length) return;
      if (active >= visible.length) active = 0;
      var slide = visible[active];
      var src = slide.getAttribute('data-src');
      var full = slide.getAttribute('data-full') || src;
      var alt = slide.getAttribute('data-alt') || '';

      if (mainImg) {
        mainImg.src = src;
        mainImg.alt = alt;
        mainImg.setAttribute('data-full', full);
      }

      // Thumbs: rebuild active state + visibility
      if (thumbsWrap) {
        Array.prototype.forEach.call(thumbsWrap.querySelectorAll('[data-thumb]'), function (t) {
          var idx = visible.indexOf(
            allSlides[parseInt(t.getAttribute('data-thumb-index'), 10)]
          );
          if (idx === -1) {
            t.style.display = 'none';
          } else {
            t.style.display = '';
            t.setAttribute('aria-current', idx === active ? 'true' : 'false');
          }
        });
      }

      // Counter + arrows visibility
      var multi = visible.length > 1;
      if (counter) counter.style.display = multi ? '' : 'none';
      if (prevBtn) prevBtn.style.display = multi ? '' : 'none';
      if (nextBtn) nextBtn.style.display = multi ? '' : 'none';
      if (counterCur) counterCur.textContent = String(active + 1);
      if (counterTot) counterTot.textContent = String(visible.length);
    }

    function go(delta) {
      if (!visible.length) return;
      active = (active + delta + visible.length) % visible.length;
      render();
    }

    function setActive(slideEl) {
      var idx = visible.indexOf(slideEl);
      if (idx === -1) return;
      active = idx;
      render();
    }

    // Thumbnail clicks
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]');
        if (!t) return;
        var slide = allSlides[parseInt(t.getAttribute('data-thumb-index'), 10)];
        setActive(slide);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    // Magnifier lens (desktop hover)
    if (magnify && mainImg) {
      magnify.addEventListener('mouseenter', function () {
        if (!isTouch) {
          // swap to hi-res for the zoom
          var full = mainImg.getAttribute('data-full');
          if (full && mainImg.src !== full) mainImg.src = full;
          magnify.classList.add('is-zoom');
        }
      });
      magnify.addEventListener('mouseleave', function () {
        magnify.classList.remove('is-zoom');
        mainImg.style.transformOrigin = 'center center';
      });
      magnify.addEventListener('mousemove', function (e) {
        if (isTouch) return;
        var r = magnify.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
      magnify.addEventListener('click', function () {
        if (isTouch && lightbox) openLightbox();
      });
    }

    // Mobile lightbox
    function openLightbox() {
      if (!lightbox || !lightboxImg) return;
      var slide = visible[active];
      lightboxImg.src = slide.getAttribute('data-full') || slide.getAttribute('data-src');
      lightboxImg.alt = slide.getAttribute('data-alt') || '';
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    Array.prototype.forEach.call(lightboxClose, function (btn) {
      btn.addEventListener('click', closeLightbox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });

    // React to variant colour change (dispatched by variant picker)
    root.addEventListener('ko:variant-group', function (e) {
      var group = e.detail && e.detail.group;
      if (group != null) root.setAttribute('data-active-group', group);
      active = 0;
      computeVisible();
      render();
    });

    computeVisible();
    render();

    // Prefetch hi-res images once idle, so the magnifier is instant
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 800); };
    idle(function () {
      allSlides.forEach(function (s) {
        var full = s.getAttribute('data-full');
        if (full) { var im = new Image(); im.decoding = 'async'; im.src = full; }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init inside Shopify theme editor
  document.addEventListener('shopify:section:load', initAll);
})();
